import { IsNumber, IsOptional, IsString } from 'class-validator'

export class TemplateCatalogoDto {
  @IsNumber()
  id!: number

  @IsOptional()
  @IsString()
  descripcion!: string

  @IsOptional()
  @IsString()
  nombre?: string
}

export class TemplateDto extends TemplateCatalogoDto {
  data: any

  @IsOptional()
  placeholders?: any[]

  @IsString()
  html!: string

  @IsOptional()
  parameters?: any[]
}
